<template>
	<div :class="'remarkable-point-cont smaller-shadow-filter '+(isMobile ? 'mobile' : '')" :style="`left: ${posX}; top: ${posY};${customStyle}`" :data-id="rpId" v-click-outside="clickOutside">
		<div class="remarkable-spot pointer" @click="click" @mouseenter="mouseEnter" @mouseleave="mouseLeave">
			<div class="outer-spot pulsating-circle"></div>
			<div class="inner-spot"></div>
		</div>
		<div :class="'comic grid-horizontal '+position+' '+(hovered ? 'visible' : '')" data-justify="center" data-align="center" data-gap="none">
			<base-icon name="arrow_comic" class="triangle" />
			<div class="stack-vertical remarkable-point-text small-radius" :style="customLabelStyle" data-justify="center" data-align="center">
				<template v-if="caption.length">
					<!-- <p class="caption-button capitalize-first">{{caption}}</p> -->
					<p :class="'remarkable-point-correction font-regular '+(usemd ? '' : 'font-italic')+(wrap ? '' : ' text-no-wrap') + (extraSpace ? ' extra-space' : '')" v-html="utils.markdownToHtml(textBefore[$i18n.locale] ? textBefore[$i18n.locale] : textBefore )"></p>
				</template>
				<slot v-else></slot>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">

import utils from '@js/utils.js';
import { mapGetters } from 'vuex';
import cloneDeep from 'lodash.clonedeep';

export default {
	name: 'InterfaceRemarkablePoint',
	props: {
		rp: {
			type: Object,
			default: {}
		},
		position: {
			type: String,
			default: 'right'
		},
		textBefore: [String, Object],
		textAfter: {
			type: String,
			default: ''
		},
		caption: {
			type: String,
			default: ''
		},
		posX: {
			type: String,
			default: '0px'
		},
		posY: {
			type: String,
			default: '0px'
		},
		customStyle: {
			type: String,
			default: ''
		},
		customLabelStyle: {
			type: String,
			default: ''
		},
		usemd: {
			type: Boolean, 
			default: false
		},
		wrap: {
			type: Boolean,
			default: false
		},
		isBeforeAndAfter: {
			type: Boolean,
			default: false
		},
		forceZindex: {
			type: Boolean,
			default: false
		},
		extraSpace: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			visible: false,
			hovered: false,
			utils
		}
	},
	watch: {
		hovered(newHovered, oldHovered) {
			if (newHovered != oldHovered)
				this.$emit('hoverChanged', newHovered);
		}
	},
	computed: {
		...mapGetters(['isMobile']),
		rpId() {
			return this.rp.id ? this.rp.id : ''
		}
	},
	methods: {
		mouseEnter() {
			if(!this.isMobile) {
				this.hovered = true
				if(this.forceZindex) this.$el.style.zIndex = 20;
			}
		},
		mouseLeave() {
			if(!this.isMobile) {
				if(this.forceZindex) this.$el.style.zIndex = 1;

				this.hovered = false
			}
		},
		click() {
			if(!this.isMobile) this.visible = true
		},
		clickOutside() {
			if(!this.isMobile) {
				this.visible = false;
			}
		},
		touchHandler() {
			// console.log('el', this.$el)
			let me = this;
			this.$el.onclick = e => {
				// console.log(this.rp)
				this.$emit('click-rm', this.rp)
			}
		}
	},
	mounted() {
		if(this.isMobile) this.touchHandler()
	},
	beforeUnmount() {
		if(this.isMobile) this.$el.onclick = null
	}
}

</script>

<style lang="scss">
	@import '@css/variables.scss';

	.remarkable-point-cont {
		position: absolute;
		opacity: 0;
		z-index: 3;
	}

	.remarkable-point-cont.mobile {
		opacity: 1;
	}

	.remarkable-spot {
		width: 1.5rem;
		height: 1.5rem;
	}

	.remarkable-spot.hovered .inner-spot {
		width: 1.5rem;
		height: 1.5rem;
	}
	.remarkable-spot.hovered .outer-spot {
		width: 2.5rem;
		height: 2.5rem;
	}

	.remarkable-spot .inner-spot,
	.remarkable-spot .outer-spot {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		border-radius: 100rem;
		transition-property: width, height;
		transition-duration: .3s;
	}

	.remarkable-spot .outer-spot {
    width: 2rem;
    height: 2rem;
    background-color: transparent;
    border: solid 0.1rem white;
	}
	.remarkable-spot .inner-spot {
		width: 1rem;
		height: 1rem;
		background-color: var(--color-black);
		transition-delay: .1s;
		opacity: 0.6;
	}

	.remarkable-point-cont .comic {
		position: absolute;
		right: 0;
		top: 0;
		opacity: 0;
		gap: 0;
		transition-property: opacity;
		transition-duration: .5s;
		pointer-events: none;
		grid-template-columns: unset;
		z-index: 10;
	}

	.remarkable-point-cont .comic.right {
		transform: translate(98%, calc(-50% + 0.8rem));
		grid-template-areas: 'triangle comic' 
	}

	.remarkable-point-cont .comic.right .triangle {
		transform-origin: center right;
		transform: rotate(-90deg) translate(50%, 0%);
	}

	.remarkable-point-cont .comic.left {
		transform: translate(-1rem, calc(-50% + 0.8rem));
		grid-template-areas: 'comic triangle' 
	}

	.remarkable-point-cont .comic.left .triangle {
		grid-area: triangle;
		transform-origin: center right;
		transform: rotate(90deg) translate(50%, 100%);
	}

	.remarkable-point-cont .comic.top {
    transform: translate(calc(50% - 0.8rem), -100%);
    grid-template-areas:
        "comic"
        "triangle"; 
	}

	.remarkable-point-cont .comic.top .triangle {
    grid-area: triangle;
    justify-self: center;
    transform-origin: top center;
    transform: translate(0%, 50%) rotate(180deg);
	}

	.remarkable-point-cont .comic.bottom {
    transform: translate(calc(50% - 0.8rem), 1rem);
    grid-template-areas:
        "triangle"
        "comic"; 
	}

	.remarkable-point-cont .comic.bottom .triangle {
    grid-area: triangle;
    justify-self: center;
    transform-origin: top center;
    transform: translate(0%, 50%) rotate(0deg);
	}

	.remarkable-point-cont .comic.visible {
		opacity: 1;
	}

	.remarkable-point-cont .comic {
		transform: translate(1rem, 0) rotate(-90deg);
	}

	.remarkable-point-text {
		padding: 1.125rem 1rem;
		background-color: var(--color-white);
	}

	.remarkable-point-text strong {
		font-weight: var(--font-medium);
	}

	.remarkable-point-correction {
		font-family: 'arzachel';
		color: var(--color-black-text);
	}

	.remarkable-point-correction p {
		color: var(--color-black-text);
	}

	.remarkable-point-correction p:not(:first-child) {
		margin-top: 1rem;
	}

	.remarkable-point-text {
		grid-area: comic;
	}

	.remarkable-point-text > *:first-child {
		color: var(--color-gray-text);
	}

	.remarkable-point-text span {
		color: var(--color-red);
	}

	@media(max-width: $breakpoint-mlll) {
		.remarkable-point-text {
			font-size: calc(0.875 * var(--base-font-size));
			line-height: 140%;
			padding: 1rem 0.75rem;
		}
	} 

</style>
